import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ui-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'info';
  @Input() closable = false;
  @Input() title: string = '';
  @Output() onClose = new EventEmitter<void>();

  isVisible = true;

  close() {
    this.isVisible = false;
    this.onClose.emit();
  }

  get typeClass() {
    return `alert-${this.type}`;
  }

  /** error/warning sono urgenti (interrompono subito); success/info sono annunciati senza interrompere */
  get isUrgent(): boolean {
    return this.type === 'error' || this.type === 'warning';
  }
}
